export class Chat{
    name: string;
    contact_tp: string;
    chat_text: string;
    ins_dt: string;
    showdate: boolean;
    time: any;
    date: any;
    s_chat : number;
    own: boolean;
    email: string;
    user_ind: string;

    constructor(){
    }
}